import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";

import CustomTableV2 from "../../common/CustomTableV2";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";
import HTMLPreview from "../BRGPatientPrompt/components/HTMLPreview";

import { GetBRGPatientEmailLogs } from "../../redux/brg/actions";

import "./style.css";

function BRGPatientEmailLog(props) {
    const [showModal, setShowModal] = useState(false);
    const [selectedEmailLog, setSelectedEmailLog] = useState(null);

    return (
        <div className="main-container" id="brg-patient-email-log">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="BRG PATIENT EMAIL SENT LOGS"
                        description=""
                        store={props.Brg?.emailLog}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Type" },
                                { title: "Patient" },
                                { title: "Email Address" },
                                { title: "Sent" },
                                { title: "Delivered" },
                                { title: "Opened" },
                                { title: "Clicked" },
                                { title: "Registered" },
                                { title: "" },
                            ],
                            body: (el, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{el?.email_type?.toUpperCase()}</h5></td>
                                        <td><h5>{(el?.first_name + " " + el?.last_name)?.toUpperCase()}</h5></td>
                                        <td><h5>{el?.email_address}</h5></td>
                                        <td><h5>{el?.date_sent ? moment(el?.date_sent).format("YYYY-MM-DD-HH:MM") : "-"}</h5></td>
                                        <td><h5>{el?.date_delivered ? moment(el?.date_delivered).format("YYYY-MM-DD-HH:MM") : "-"}</h5></td>
                                        <td><h5>{el?.date_opened ? moment(el?.date_opened).format("YYYY-MM-DD-HH:MM") : "-"}</h5></td>
                                        <td><h5>{el?.date_clicked ? moment(el?.date_clicked).format("YYYY-MM-DD-HH:MM") : "-"}</h5></td>
                                        <td><h5>{el?.date_registered ? moment(el?.date_registered).format("YYYY-MM-DD-HH:MM") : "-"}</h5></td>
                                        <td>
                                            <Tooltip title="Preview Email" onClick={() => {
                                                setShowModal(true);
                                                setSelectedEmailLog(el);
                                            }}>
                                                <IconButton>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetBRGPatientEmailLogs(page, count, filter, sort);
                            },
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"Email Preview"}>
                <HTMLPreview content={selectedEmailLog?.email_content} />
            </CustomSliderModalV2>

        </div>
    );
}

const mapStateToProps = (state) => ({
    Brg: state.Brg,
})

export default connect(mapStateToProps, {
    GetBRGPatientEmailLogs,
})(BRGPatientEmailLog);
